import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, LayoutGrid, Plus, User } from "lucide-react";

export const BottomTabBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;

  const tabs = [
    { to: "/app", label: "Home", icon: Home, active: path === "/app" },
    { to: "/app/templates", label: "Templates", icon: LayoutGrid, active: path === "/app/templates" },
    { to: "/app/profile", label: "Profile", icon: User, active: path === "/app/profile" },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 pb-[env(safe-area-inset-bottom)]">
      <div className="mx-auto max-w-md px-4 pb-3">
        <div className="relative flex items-center justify-around rounded-[26px] border border-black/5 bg-white/80 px-2 py-2 backdrop-blur-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)]">
          {tabs.slice(0, 1).map((t) => (
            <TabBtn key={t.to} tab={t} onClick={() => navigate(t.to)} />
          ))}
          <button
            onClick={() => navigate("/app/templates")}
            data-testid="tab-create-button"
            className="tap-scale -mt-6 grid place-items-center w-14 h-14 rounded-full bg-ho-primary text-white shadow-[0_8px_24px_rgba(0,85,255,0.4)]"
            aria-label="Create"
          >
            <Plus className="w-7 h-7" strokeWidth={2.5} />
          </button>
          {tabs.slice(1).map((t) => (
            <TabBtn key={t.to} tab={t} onClick={() => navigate(t.to)} />
          ))}
        </div>
      </div>
    </div>
  );
};

const TabBtn = ({ tab, onClick }) => {
  const Icon = tab.icon;
  return (
    <button
      onClick={onClick}
      data-testid={`tab-${tab.label.toLowerCase()}`}
      className="tap-scale flex flex-1 flex-col items-center gap-0.5 py-1"
    >
      <Icon className={`w-6 h-6 ${tab.active ? "text-ho-primary" : "text-ho-muted"}`} strokeWidth={tab.active ? 2.4 : 2} />
      <span className={`text-[10px] font-semibold ${tab.active ? "text-ho-primary" : "text-ho-muted"}`}>{tab.label}</span>
    </button>
  );
};
